export default "__VITE_ASSET__B7fPjH1E__"